<template>
    <div class="gallery-container">
        <a-card :bordered="false">
            <div class="gallery-modal">
                <div class="gallery-main">
                    <img
                            v-if="typeof currentImage === 'string'"
                            :src="currentImage"
                            :alt="currentImage"
                            class="gallery-main-image"
                    />
                </div>
            </div>
        </a-card>
    </div>
</template>

<script setup>
    import { ref, computed,  defineProps, onMounted, onUnmounted} from 'vue';

    // Props：接收图片数据
    const props = defineProps({
        data: Array
    });


    // 响应式数据
    const currentIndex = ref(0);

    // 计算当前图片
    const currentImage = computed(() => {
        return props.data[currentIndex.value] || '';
    });

    // 方法
    const openGallery = (index) => {
        currentIndex.value = index;
    };


    const timer = ref(null);
    // 监听键盘事件
    onMounted(() => {
        timer.value = setInterval(()=>{
            if (currentIndex.value >= props.data.length - 1) {
                currentIndex.value = -1;
            } else openGallery(currentIndex.value);
            currentIndex.value += 1;
        }, 3000);

    });

    onUnmounted(() => {
        if(timer.value) clearInterval(timer.value);
    });
</script>

<style scoped>
    .gallery-container {
        padding: 20px;
    }




    /* 画廊模态框 */
    .gallery-modal {
        padding: 20px;
    }

    .gallery-main {
        position: relative;
        margin-bottom: 20px;
        min-height: 315px;
    }

    .gallery-main-image {
        width: 100%;
        max-height: 600px;
        object-fit: contain;
        border-radius: 8px;
    }


    .gallery-thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }


    /* 全屏模态框样式 */
    :deep(.fullscreen-modal .ant-modal-content) {
        background: rgba(0, 0, 0, 0.9);
        border: none;
    }

    :deep(.fullscreen-modal .ant-modal-body) {
        padding: 0;
    }
</style>